var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrowserOther(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23156_15793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.9869 22.0453C2.31897 25.1507 4.81534 27.6484 7.91764 27.9943C12.6828 28.5257 17.3172 28.5257 22.0824 27.9943C25.1848 27.6484 27.681 25.1507 28.0132 22.0453C28.5195 17.3108 28.5195 12.6892 28.0132 7.95463C27.681 4.84929 25.1848 2.35168 22.0824 2.00571C17.3172 1.47429 12.6828 1.47429 7.91764 2.00571C4.81534 2.35168 2.31897 4.84929 1.9869 7.95463C1.4806 12.6892 1.4806 17.3108 1.9869 22.0453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9869 22.0453C2.31897 25.1507 4.81534 27.6484 7.91764 27.9943C12.6828 28.5257 17.3172 28.5257 22.0824 27.9943C25.1848 27.6484 27.681 25.1507 28.0132 22.0453C28.5195 17.3108 28.5195 12.6892 28.0132 7.95463C27.681 4.84929 25.1848 2.35168 22.0824 2.00571C17.3172 1.47429 12.6828 1.47429 7.91764 2.00571C4.81534 2.35168 2.31897 4.84929 1.9869 7.95463C1.4806 12.6892 1.4806 17.3108 1.9869 22.0453Z",
    stroke: "#9059FF",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0742 8.53346H1.92627C1.94622 8.34009 1.96654 8.14715 1.98712 7.95463C2.31919 4.84929 4.81556 2.35168 7.91786 2.00571C12.6831 1.47429 17.3175 1.47429 22.0826 2.00571C25.185 2.35168 27.6814 4.84929 28.0134 7.95463C28.0339 8.14715 28.0543 8.34009 28.0742 8.53346Z",
    fill: "#F4EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0742 8.53346H1.92627C1.94622 8.34009 1.96654 8.14715 1.98712 7.95463C2.31919 4.84929 4.81556 2.35168 7.91786 2.00571C12.6831 1.47429 17.3175 1.47429 22.0826 2.00571C25.185 2.35168 27.6814 4.84929 28.0134 7.95463C28.0339 8.14715 28.0543 8.34009 28.0742 8.53346Z",
    stroke: "#9059FF",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23156_15793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserOther);
export default __webpack_public_path__ + "static/media/browser_other.1cbadfa46a2d7abeb617d36dca33c95a.svg";
export { ForwardRef as ReactComponent };